import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthContainer from '../../../components/auth/AdminAuthContainer';
import AuthHeader from '../../../components/auth/AdminAuthHeader';
import Card from '../../../components/ui/Card';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

import { toast } from 'react-toastify';
import authService from '../../../services/admin/authService';
import { validateEmail } from '../../../utils/validation/passwordValidation';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [resetData, setResetData] = useState(null);

   const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate email
    const emailValidation = validateEmail(email);
    if (!emailValidation.isValid) {
      setError(emailValidation.error);
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      const response = await authService.requestPasswordReset(email);     
      
      // Store userId in session for next steps
      if(response.data) {
        toast.success(response.message);
        setResetData(response.data);
        setSuccess(true);

        localStorage.setItem('reset_userId', response.data.userId);
        localStorage.setItem('reset_email', response.data.email);

        // Navigate to Reset Password page with state
        navigate('/hpanel/reset-password', {
          state: {
            userId: response.data.userId,
            email: response.data.email
          }
        });
      } else {
        toast.error('Verification code data not received. Please try again.');
      }
      
    } catch (error) {
      // Handle specific error messages
      if (error.response?.data?.message) {
        //setError(error.response.data.message);
        toast.error(error.response.data.message);
      } else if (error.message) {
        //setError('Failed to send verification code. Please try again.');
        toast.error('Failed to send verification code');
      }
    } finally {
      setLoading(false);
    }
  };

  /*const handleResendCode = async () => {
    if (!resetData?.userId) {
      toast.error('Unable to resend code. Please try the reset process again.');
      return;
    }
    
    setLoading(true);
    
    try {
      const response = await authService.resendVerificationCode(resetData.userId);
      toast.success(response.message || 'Verification code resent successfully');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to resend code');
    } finally {
      setLoading(false);
    }
  };

  const handleProceedToReset = () => {
    navigate('/hpanel/reset-password', {
      state: {
        userId: resetData?.userId,
        email: resetData?.email
      }
    });
  };*/
  
  return (
    <>
      {/* SEO Settings */}
      <title>{`Forgot Password | ${process.env.REACT_APP_NAME}`}</title>
      <meta name="robots" content="noindex, nofollow" />

      <AuthContainer>
        <AuthHeader />
        
        <Card>
          <form onSubmit={handleSubmit}>
            <Input
              type="email"
              label="Admin Email"
              icon="fas fa-envelope"
              placeholder="admin@hunarpool.com"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError('');
              }}
              required
            />
            {error && (
              <p className="mt-2 text-sm text-red-600">{error}</p>
            )}
            
            <Button type="submit" variant="primary" className="w-full mb-4" disabled={loading}>
              { loading ? ('Sending Verification Code...') : ('Send Verification Code') }
            </Button>
            
            <div className="text-center">
              <Link 
                to="/hpanel/login" 
                className="text-primary-600 font-medium hover:text-primary-700 flex items-center justify-center"
              >
                <i className="fas fa-arrow-left mr-2"></i> Back to Sign In
              </Link>
            </div>
          </form>
        </Card>
      </AuthContainer>
    </>
  );
};

export default ForgotPassword;